import { useQuery } from "@apollo/client";
import { MY_HR_GET_STREET_TYPES } from "my-hr/graphql";

export const useMyHrStreetTypes = () => {
  const { data, loading, error } = useQuery(MY_HR_GET_STREET_TYPES, {
    fetchPolicy: "cache-and-network",
  });

  const result = data?.streetTypes || [];

  return {
    data: result,
    loading,
    error,
  };
};

export default useMyHrStreetTypes;
